import { parse } from 'query-string';

/**
 * 从url中提取查询参数对应name的值
 *
 * @param name
 * @param url
 * @example
 *
 * getQuery('http://xxx.jd.com/a/b?a=1')
 * // '1'
 */
function getQuery(name: string, url?: string) {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/**
 * 从url中提取查询参数对应name的值
 *
 * @param url
 * @example
 *
 * getQuery('http://xxx.jd.com/a/b?a=1')
 * // {a : 1}
 */
function getUrlObject(url?: string) {
  if (!url) {
    url = window.location.search;
  }
  const obj = parse(url);
  return obj;
}

function scrollWindowTo(y: number) {
  window.scroll({
    top: y,
    left: 0,
    behavior: 'smooth',
  });
}

/**
 * 路由跳转
 *
 * @param href
 * @param newTab
 * @example
 *
 * goto('http://jd.com')
 * // 当前页面打开当前地址
 *
 * goto('http://jd.com', true)
 * // 新tab打开当前地址
 */
function goto(href: string, newTab = false) {
  if (newTab) window.open(href);
  else window.location.href = href;
}

/**
 * 依据height: 939计算元素缩放比例
 *
 * @param minHeight
 * @example
 *
 * getResizePercent(939)
 * // 1
 */
function getResizePercent(minHeight = 939 /* mac pro的全屏高度 */) {
  const screenHeight = document.documentElement.clientHeight || document.body.clientHeight;
  if (screenHeight > minHeight) return 1;
  return Math.floor((screenHeight / minHeight) * 100) / 100;
}

export { getQuery, scrollWindowTo, goto, getResizePercent, getUrlObject };
